module.exports = __webpack_public_path__ + "img/python-icon.19585ce3.svg";